module.exports = __webpack_public_path__ + "img/b5-2.32a0cc5.png";